import { Upload } from 'antd'

import ActionIcon from './ActionIcon'
import useInputUpload from '@/hooks/useInputUpload'
const Icon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.58333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H15.8333C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V12.5L14.9167 9.91667C14.6031 9.60931 14.1809 9.43813 13.7418 9.44032C13.3027 9.4425 12.8822 9.61788 12.5717 9.92833L5 17.5"
      stroke="#1C1F23"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.49998 9.16668C8.42045 9.16668 9.16665 8.42048 9.16665 7.50001C9.16665 6.57954 8.42045 5.83334 7.49998 5.83334C6.57951 5.83334 5.83331 6.57954 5.83331 7.50001C5.83331 8.42048 6.57951 9.16668 7.49998 9.16668Z"
      stroke="#1C1F23"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4165 14.9989C15.4165 14.5847 15.0807 14.2489 14.6665 14.2489C14.2523 14.2489 13.9165 14.5847 13.9165 14.9989V15.9156H13C12.5858 15.9156 12.25 16.2514 12.25 16.6656C12.25 17.0799 12.5858 17.4156 13 17.4156H13.9165V18.3322C13.9165 18.7464 14.2523 19.0822 14.6665 19.0822C15.0807 19.0822 15.4165 18.7464 15.4165 18.3322V17.4156H16.3333C16.7475 17.4156 17.0833 17.0799 17.0833 16.6656C17.0833 16.2514 16.7475 15.9156 16.3333 15.9156H15.4165V14.9989Z"
      fill="#0077FA"
    />
  </svg>
)
const ImageUpload = () => {
  const { uploadLoading, beforeUploadImage } = useInputUpload()

  return (
    <Upload
      accept="image/*"
      multiple={true}
      beforeUpload={beforeUploadImage}
      maxCount={6}
      showUploadList={false}
    >
      <ActionIcon
        title="支持jpg、jpeg、png等图片格式，一次最多上传6张图片，单张不超过10M"
        Icon={Icon}
        loading={uploadLoading}
      />
    </Upload>
  )
}

export default ImageUpload
